<template>
    <div class="home">
        <div class="home-container nj-cols c3" v-if="usuario">
            <div class="group">
                <div class="group-title">Proyectos</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/empleado" v-if="activar('EMPLEADOS')">Empleados</router-link>
                    <router-link class="option" to="/proyecto" v-if="activar('PROYECTOS')">Proyectos</router-link>
                </div>
            </div>
            <div class="group">
                <div class="group-title">Ordenes</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/pedidoItems" v-if="activar('PEDIDO_ITEMS')">Pedidos de compra</router-link>
                    <router-link class="option" to="/orden" v-if="activar('ORDENES_DE_COMPRA')">Ordenes de compra</router-link>
                    <router-link class="option" to="/orden/approve" v-if="false">Ordenes Pendientes</router-link>
                    <router-link class="option" to="/centroCosto" v-if="activar('CENTRO_DE_COSTOS')">Centros de Costo</router-link>
                    <router-link class="option" to="/caja" v-if="activar('CAJAS')">Cajas</router-link>
                </div>
            </div>
            <div class="group">
                <div class="group-title">Productos</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/producto" v-if="activar('PRODUCTOS')">Productos</router-link>
                    <router-link class="option" to="/proveedor" v-if="activar('PROVEEDORES')">Proveedores</router-link>
                    <router-link class="option" to="/marca" v-if="activar('MARCAS')">Marcas</router-link>
                    <router-link class="option" to="/unidad" v-if="activar('UNIDADES')">Unidades</router-link>
                </div>
            </div>
            <div class="group">
                <div class="group-title">Inventario</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/inventario" v-if="activar('INVENTARIO')">Inventario</router-link>
                    <router-link class="option" to="/transferencia" v-if="activar('TRANSFERENCIAS')">Transferencias</router-link>
                    <router-link class="option" to="/asignaciones" v-if="activar('ASIGNACIONES')">Asignaciones</router-link>
                </div>
            </div>
            <div class="group">
                <div class="group-title">Seguridad</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/usuario" v-if="activar('USUARIOS')">Usuarios</router-link>
                </div>
            </div>
            <!-- <div class="group">
                <div class="group-title">Ventas</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/cliente" v-if="activar('CLIENTES')">Clientes</router-link>
                    <router-link class="option" to="/productoVenta" v-if="activar('PRODUCTOS_VENTA')">Producto</router-link>
                    <router-link class="option" to="/ordenVenta" v-if="activar('ORDENES_VENTA')">Pedido</router-link>
                </div>
            </div>
            <div class="group">
                <div class="group-title">Operaciones</div>
                <div class="group-content nj-cols form c2">
                    <router-link class="option" to="/mixers" v-if="activar('MIXERS')">Mixers</router-link>
                    <router-link class="option" to="/vendedor" v-if="activar('VENDEDORES')">Vendedores</router-link>
                    <router-link class="option" to="/envios" v-if="activar('ENVIOS')">Despachos</router-link>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import StoreAdapter from "../store/StoreAdapter"
import Acceso from "../util/acceso"
export default {
    name: "Home",
    data() {
        return {

        }
    },
    computed: {
        usuario() {
            return StoreAdapter.get(StoreAdapter.modules.UsuarioStore.getters.usuario)
        }
    },
    methods: {
        activar(modulo) {
            return Acceso.activarModulo(modulo)
        }
    },
    mounted() {

    }
}
</script>
<style scoped>
.home {
    width: 100%;
    display: flex;
    justify-content: center;
}

.home-container {
    width: 100%;
    max-width: 1000px;
}

.group {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 4px;
}

.group-title {
    font-size: 10px !important;
    margin: 0 4px 8px 4px;
    font-weight: bold;
}

.option {
    background-color: #f4f4f4;
    padding: 12px;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #ccc;
}

.option:hover {
    color: #fff !important;
    border-color: var(--nj-color-blue);
    background-color: var(--nj-color-blue);
}
</style>